import { getApi } from "./api_instance";

export const unSeenNotificationCount = async (dispatch) => {
  try {
    return await getApi({
      apiUrl: "/projects/api/notification/getNotificationCount",
      dispatch,
      sendToken: true,
    });
  } catch (error) {
    throw error;
  }
};
